<template>
  <section class="keep-local">
    <div class="keep-local__content container">
      <div class="keep-local__text">
        <h3 class="keep-local__subtitle --fade-in-left" data-vertical-ivp-class="--animate">HOW TO KEEP BIG-CANNA AWAY?</h3>
        <h1 class="keep-local__title">
          Keeping Cannabis Local is the Solution.
        </h1>
        <p class="keep-local__description">
          Unity Rd. shops are rolling out state-by-state, community-by-community
          spanning the nation, and keeping dispensary ownership in the hands of
          local entrepreneurs.
          <br /><br />
          The franchise opportunity provides a solution for industry newcomers
          and small, locally owned and operated dispensaries to compliantly
          thrive, thanks to the robust backing and support of a national
          franchise.
          <br /><br />
          Unity Rd. offers direct access to the buying power, resources and
          supportive network normally reserved for multi-unit cannabis operators
          – empowering local, independent operators to confidently open their
          doors each day. We believe cannabis entrepreneurship can be a
          life-changing opportunity for families that can create wealth for
          generations to come.
          <br /><br />
          You’re investing in an organization that’s building a national
          community of local cannabis entrepreneurs, changing lives for their
          families and surrounding communities by keeping the wealth cannabis
          offers in their neighborhoods.
        </p>
        <div class="keep-local__features --fade-in-left" data-vertical-ivp-class="--animate">
          <div class="keep-local__singleft">
            <img src="../assets/keep-local/darts.svg" />
            <h2 class="title">Compliantly Thrive</h2>
            <p class="description">
              The Unity Rd. franchise gives locally owned dispensaries the
              resources and tools to create wealth for generations to come.
            </p>
          </div>
          <div class="keep-local__singleft">
            <img src="../assets/keep-local/hands.svg" />
            <h2 class="title">National Community</h2>
            <p class="description">
              We are building a national community of local owners, that can
              learn, build, and grow together.
            </p>
          </div>
        </div>
        <div class="keep-local__btn">
          <a class="button-outlined --text-dark"
              href="https://item9labs.app.dealmaker.tech/invitations/1aa03026-7402-4585-8c13-aef7985768b8/view"
              target="_blank">
            <div class="text">Invest Now</div>
            <div class="line -right"></div>
            <div class="line -top"></div>
            <div class="line -left"></div>
            <div class="line -bottom"></div>
          </a>
        </div>
      </div>
      <div class="keep-local__container">
        <div class="keep-local__img1 keep-local__img-container">
          <img src="../assets/keep-local/img-1.jpeg" />
        </div>
        <div class="keep-local__container-imgs">
          <div class="keep-local__img2 keep-local__img-container">
            <img src="../assets/keep-local/img-2.jpeg" />
          </div>
          <div class="keep-local__img3 keep-local__img-container">
            <img src="../assets/keep-local/img-3.jpeg" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "KeepLocal",
  data() {
    return {};
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/KeepLocal.scss";
</style>
